import type { SVGProps } from "react";

const Gray = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="220" height="199" viewBox="0 0 220 199" fill="none" {...props}>
    <ellipse cx="110" cy="105.658" rx="75.2632" ry="75.2632" fill="url(#paint0_linear_1441_6213)" />
    <g filter="url(#filter0_dd_1441_6213)">
      <path
        d="M120.559 96.384C117.524 98.6424 113.854 99.8775 110.079 99.8422C106.303 99.8422 102.598 98.6424 99.563 96.384L43.35 54.4271V126.378C43.3147 132.201 48.0079 136.965 53.8304 137H166.221C172.044 136.965 176.737 132.201 176.702 126.378V54.4271L120.559 96.384Z"
        fill="url(#paint1_linear_1441_6213)"
      />
      <path
        d="M67.111 10C64.9018 10 63.111 11.7909 63.111 14V60.5317L103.692 90.7379C107.467 93.4903 112.655 93.4903 116.43 90.7379L156.623 60.7788V14C156.623 11.7909 154.832 10 152.623 10H67.111ZM88.1651 38.23H107.22C109.161 38.23 110.749 39.818 110.749 41.7588C110.749 43.6996 109.161 45.2875 107.22 45.2875H88.1651C86.2243 45.2875 84.6364 43.6996 84.6364 41.7588C84.6364 39.818 86.2243 38.23 88.1651 38.23ZM131.922 62.9313H88.1651C86.2243 62.9313 84.6364 61.3434 84.6364 59.4025C84.6364 57.4617 86.2243 55.8738 88.1651 55.8738H131.922C133.862 55.8738 135.45 57.4617 135.45 59.4025C135.45 61.3434 133.862 62.9313 131.922 62.9313Z"
        fill="url(#paint2_linear_1441_6213)"
      />
    </g>
    <circle cx="30.3947" cy="57.8947" r="7.23684" fill="white" />
    <ellipse cx="26.0527" cy="188.158" rx="10.1316" ry="10.1316" fill="white" />
    <ellipse cx="209.868" cy="81.0526" rx="10.1316" ry="10.1316" fill="white" />
    <ellipse cx="193.947" cy="41.9737" rx="5.78947" ry="5.78947" fill="white" />

    <defs>
      <filter
        id="filter0_dd_1441_6213"
        x="26.6831"
        y="10"
        width="166.685"
        height="160.333"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="3.33333" operator="erode" in="SourceAlpha" result="effect1_dropShadow_1441_6213" />
        <feOffset dy="6.66667" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1441_6213" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="3.33333" operator="erode" in="SourceAlpha" result="effect2_dropShadow_1441_6213" />
        <feOffset dy="16.6667" />
        <feGaussianBlur stdDeviation="10" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_1441_6213" result="effect2_dropShadow_1441_6213" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1441_6213" result="shape" />
      </filter>
      <filter
        id="filter1_b_1441_6213"
        x="74"
        y="117"
        width="72"
        height="72"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="4" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1441_6213" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1441_6213" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_1441_6213"
        x1="110"
        y1="30.3948"
        x2="110"
        y2="180.921"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F3EDFA" />
        <stop offset="1" stopColor="#EBEAED" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1441_6213"
        x1="159.593"
        y1="67.1306"
        x2="145.837"
        y2="135.469"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9FAFB" />
        <stop offset="1" stopColor="#E4E7EC" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1441_6213"
        x1="144.625"
        y1="22.7388"
        x2="125.672"
        y2="88.5882"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9FAFB" />
        <stop offset="1" stopColor="#E4E7EC" />
      </linearGradient>
    </defs>
  </svg>
);

export const IllustrationMail = {
  Gray,
};
